module.exports = __webpack_public_path__ + "img/795-4a471d.png";